<template>
  <div>
    <!-- 搜索区域 -->
    <SiruiSearch
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
      @changeMethod="changeMethod"
    ></SiruiSearch>
    <!--内容区域-->
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :setting="false"
        :customVisible="false"
        :showFooter="1 == 1"
        :footerMethod="footerTotalCols ? footerMethodTotal : null"
        rowKey="contractNo"
        @dblclickEvent="dblclickEvent"
        @chooseClick="chooseClick"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column
          v-for="(item, index) in columnListDefault"
          :key="index"
          :type="item.type"
          :visible="item.visible"
          :fixed="item.fixed"
          :width="item.width"
          :sortable="item.sortable"
          :formatter="item.formatter"
          :field="item.field"
          :title="item.title"
        >
          <template slot-scope="scope">
            <span v-if="item.dictType">
              {{ scope.row[item.field] | getDictNameByCode(item.dictType) }}
            </span>
            <span v-else-if="item.format">
              {{ scope.row[item.field] | formatTableColumn(item.format) }}
            </span>
            <span v-else-if="item.field == 'isGenerateSales'">
              {{ scope.row[item.field] ? '是' : '否' }}
            </span>
            <span v-else-if="item.field == 'contractShippingStatus'">
              {{ scope.row[item.field] ? '执行中' : '未执行' }}
            </span>
            <!-- <span v-else-if="item.field == 'shipComplete'"> 否 </span> -->
            <span v-else-if="item.field == 'contractValidStart'">
              <template v-if="scope.row['contractValidStart'] && scope.row['contractValidEnd']">
                {{ scope.row['contractValidStart'] }}至{{ scope.row['contractValidEnd'] }}
              </template>
            </span>
            <span v-else-if="item.field == 'liquidatedDamagesType'">
              {{ getValueName(item.field, scope.row[item.field]) }}
            </span>
            <template v-else-if="item.field == 'oaUrl'">
              <a
                href="javascript:void(0);"
                v-if="scope.row[item.field]"
                @click="goOaLink(scope.row[item.field])"
                >查看</a
              >
            </template>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
    <ChoiceType ref="choiceTypeRef" />
    <OriginalsReceivedDialog
      ref="OriginalsReceivedDialog"
      :vFlag="'purchase'"
      @confirm="resetBtnClick"
    />
    <SiruiUpload
      ref="siruiUpload"
      isShowDownTemplateBtn
      @getData="getTableData"
      :action="action"
      :data="importData"
    />
  </div>
</template>

<script>
  import { tableColumnListDefault, fromColumns } from './index.js';
  import tableMixins from '@/common/mixins/table.js';
  import indexBtnMixin from './indexBtnMixin.js';
  import ChoiceType from '../../components/choiceType';
  import API from '@/api/purchaseSalesCenter/wumaoPurchaseSales.js';
  import OriginalsReceivedDialog from '../../components/originalsReceivedDialog.vue';
  import SiruiUpload from '@/components/SiruiUpload';
  export default {
    name: 'WuMaoList',
    mixins: [tableMixins, indexBtnMixin],
    data() {
      return {
        footerTotalCols: {
          amount: ['contractTotalAmount'],
          quantity: ['productQuantity'],
        }, //底部合计列-字段名，数字类型金额amount，数量quantity等）判断小数点
        query: {
          contractType: null,
          contractDetailCategory: '',
          externalContractNo: null,
          intentionNo: null,
          contractNo: null,
          tradeType: null,
          contractCreateStartDate: null,
          contractCreateEndDate: null,
          storage: null,
          amountStart: undefined,
          amountEnd: undefined,
          // customer: null,
          product: null,
          settleBatchNumber: null,
          priceStart: undefined,
          priceEnd: undefined,
          quantityStart: undefined,
          quantityEnd: undefined,
          contractBusinessCompanyNo: null,
          contractBusinessDepartment: null,
          contractSalesman: null,
          contractOperaterNo: null,
          supplier: null,
          contractStatus: null,
          lastestPayMoneyDay: null,
          lastestReceiveProductDay: null,
          supplychain: null,
          businessType: null,
          isFixedPrice: null,
          isPrepay: null,
          businessOrder: null, //业务订单
          receiptCondition: null, //付款条件
          isNotProxy: null, //贸易合同-非代理,1-是,0-否',
          distributionBatchNo: null,
          originalsReceivedBusiness: null,
          originalsReceivedRm: null,

          //新增字段
          pricingRule: null,
          shipComplete: null,
          contractValidStart: null,
          contractValidEnd: null,
          projectInitiationNo: null,
          isPersonalPartner: null,
        },
        departmentList: [],
        isIntention: '',
        //意向单号禁用状态
        intDisabled: false,
        //合同号禁用状态
        contDisabled: false,
        //排序条件
        sortParams: '',
      };
    },
    watch: {
      $route() {
        this.getData(); // 监听路由变动调用接口
      },
    },
    computed: {
      importData() {
        return {
          tenantCode: this.userInfo.userInfo.tenantCode,
          companyCode: this.userInfo.userInfo.companyCode,
          companyName: this.userInfo.userInfo.companyName,
          departmentCode: this.userInfo.userInfo.departmentCode,
          departmentName: this.userInfo.userInfo.departmentName,
          belongTenantCode: this.userInfo.userInfo.tenantCode,
          dataGroup: 'wm',
          access_token: this.userInfo.userInfo.access_token,
          lang: this.lang,
        };
      },
      action() {
        return API.IMPORT_ORDER_API;
      },
      searchColumns() {
        return fromColumns(this);
      },
      columnListDefault() {
        return tableColumnListDefault(this);
      },
    },
    mounted() {
      if (this.$route.query.contractDetailCategory) {
        this.query.contractDetailCategory = this.$route.query.contractDetailCategory;
        this.getData();
      }
      // this.query.customer = this.userInfo.userInfo.companyCode;
      this.$nextTick(() => {
        this.getButtonList();
        this.getDepartment();
        this.getData();
      });
    },
    methods: {
      getButtonList() {
        this.getButtons().then((e) => {
          let list = [];
          if (e && e.length != 0) {
            for (let item of e) {
              if (item.label != '导入' && item.label != '正本收集' && item.label != '正本归档') {
                list.push(item);
              }
            }
          }
          this.menuButtonList = list;
        });
      },
      getTableData() {},

      getValueName(field, value) {
        if (!value || value == '') {
          return '';
        }
        if (field == 'liquidatedDamagesType') {
          if (value == 'FIXED') {
            return '按固定值';
          } else if (value == 'RATE') {
            return '按利率';
          }
        }
        return '';
      },
    },
    components: {
      ChoiceType,
      OriginalsReceivedDialog,
      SiruiUpload,
    },
  };
</script>

<style></style>
